/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import { Chip, useTheme } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';

import { ICustomTheme } from 'interfaces';

type ItemType = {
  value?: string;
  label: string;
};

type ChipsProps = {
  list: ItemType[];
  handleDelete: any;
  backgroundColor?: string;
};

export const Chips = ({
  list,
  handleDelete,
  backgroundColor,
}: ChipsProps): JSX.Element => {
  const theme: ICustomTheme = useTheme();

  return (
    <React.Fragment>
      {list.map(({ value, label }: ItemType) => (
        <Chip
          label={label}
          key={value}
          onDelete={() => handleDelete(value)}
          color="secondary"
          css={{
            color: theme.colors.white,
            fontSize: theme.typography.h4.fontSize,
            fontWeight: theme.typography.fontWeightBold,
            margin: theme.spacing(2, 1),
            borderRadius: 3,
            backgroundColor:
              backgroundColor || theme.colors.paletteFromBO.secondary,
          }}
          deleteIcon={
            <ClearIcon color="inherit" css={{ color: theme.colors.white }} />
          }
        />
      ))}
    </React.Fragment>
  );
};
